/*
 * Language switcher: clicking a flag sets locale_code on the nearest
 * {% form 'localization' %} and submits it. Shopify's localization form
 * handles the redirect/cookie — this is just the click -> submit wiring.
 *
 * Picking the language that's already active only closes the panel; there is
 * nothing to switch to and a reload would look like a dead click.
 */
(function () {
  'use strict';

  if (window.__galasLangSwitcherBound) return;
  window.__galasLangSwitcherBound = true;

  function closeAll(except) {
    document.querySelectorAll('[data-lang-picker][open]').forEach(function (picker) {
      if (picker !== except) picker.open = false;
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-locale]');

    if (!button) {
      // Clicking anywhere outside an open panel dismisses it.
      var insidePicker = event.target.closest('[data-lang-picker]');
      closeAll(insidePicker);
      return;
    }

    var picker = button.closest('[data-lang-picker]');
    var form = button.closest('[data-lang-switcher-form]');
    if (!form) return;

    event.preventDefault();

    if (button.classList.contains('is-active')) {
      if (picker) picker.open = false;
      return;
    }

    var input = form.querySelector('[data-lang-switcher-input]');
    if (input) input.value = button.getAttribute('data-locale');
    form.submit();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' || event.key === 'Esc') closeAll(null);
  });
})();
